import Draggable20 from '@carbon/icons-react/es/draggable/20';
import { Tooltip } from 'antd';
import { camelCase } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Button } from 'components/atoms/button';
import type { DragHandlePosition } from './types';

const DraggableHandle = styled(Button)`
  cursor: grab;
  width: var(--height-lg);
  :hover {
    background: none;
  }
`;

export const DragHandle = (props) => {
  const { title } = props;

  return (
    <Tooltip
      title={<FormattedMessage id="drag_reorder" />}
      mouseEnterDelay={0.8}
    >
      <DraggableHandle
        {...props}
        hideHoverBorderRadius
        type="text"
        size="small"
        icon={<Draggable20 style={{ color: 'var(--icon-secondary)' }} />}
        data-cy={`drag_handle.${camelCase(title)}`}
      />
    </Tooltip>
  );
};

export const SortableElementContainer = styled.div<{ isDragOverlay?: boolean }>`
  ${ifProp(
    'isDragOverlay',
    css`
      z-index: calc(var(--zindex-popover-high) + 1);
      background: var(--blue-10);
      outline: 2px solid var(--blue-60);
      display: flex;
      align-items: center;
      height: var(--height-base);
    `,
  )};
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: var(--height-base);
  padding: 0 var(--spacing-03);
  :hover {
    background: var(--item-hover-bg);
  }
`;

export const ListElement = ({
  item,
  dragHandlePosition,
  listeners = {},
  disabled = false,
}) => {
  return (
    <ListItem>
      {(dragHandlePosition as DragHandlePosition) === 'left' && !disabled ? (
        <DragHandle title={item.title} {...listeners} />
      ) : null}
      {item.listItem}
      {(dragHandlePosition as DragHandlePosition) === 'right' && !disabled ? (
        <DragHandle title={item.title} {...listeners} />
      ) : null}
    </ListItem>
  );
};
